import React from 'react';
import * as I18n from 'i18n-js';
import gql from 'graphql-tag';
import {
  CheckoutCreditCardWalletFields,
} from '../schemas/rql';
import { Link, withRouter, WithRouterProps } from 'react-router';
import { Paths } from './shared/url_helpers';

import CreditCardBrandIcon from './credit_card_brand_icon';
import { RCButton } from '@reverbdotcom/commons/src/rc/RCButton';

type Checkout = CheckoutCreditCardWalletFields.Fragment;

interface ExternalProps {
  checkout: Checkout;
  children: React.ReactNode;
}

type Props = ExternalProps & WithRouterProps;

export function CheckoutCreditCardWallet(props: Props) {
  const isCreditCardSet = props.checkout.creditCard?.id;
  const shippingAddressId = props.checkout.shippingAddress?.id;
  const cardPath = Paths.checkoutCreditCardWallet.expand({
    checkoutId: props.checkout.id,
    selected_card_id: props.checkout.creditCard?.id,
    selected_shipping_address_id: shippingAddressId,
  });

  return (
    <>
      <div className="d-flex fx-justify-between">
        {isCreditCardSet &&
          <div className="d-flex">
            <div style={{ width: '5rem' }}>
              <CreditCardBrandIcon
                brand={props.checkout.creditCard.brand}
              />
            </div>
            <div className="pl-1">
              <div className="weight-bold">
                {props.checkout.creditCard.display.summary}
              </div>
              <div className="size-80">
                {props.checkout.creditCard.display.expirationDate}
              </div>
            </div>
          </div>
        }
        <Link to={cardPath}>
          <RCButton>
            {isCreditCardSet
              ? I18n.t('discovery.checkout.creditCardWallet.modalButtonChange')
              : I18n.t('discovery.checkout.creditCardWallet.modalButtonSelect')
            }
          </RCButton>
        </Link>
      </div>
      {props.children}
    </>
  );
}

export const CheckoutCreditCardWalletFragment = gql`
  fragment CheckoutCreditCardWalletFields on Checkout {
    _id
    id
    shippingAddress {
      uuid
      id
    }
    creditCard {
      id
      brand {
        type
        name
      }
      display {
        summary
        expirationDate
      }
    }
  }
`;

export default withRouter(CheckoutCreditCardWallet);
